<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()&&!isMB">
        <el-button size="mini" type="success" plain @click="importTT">导入课程表</el-button>
        <el-button size="mini" type="primary" @click="exportTT">导出课程表</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button type="text" v-if="$permission.canWrite()" @click="edit(row)">设置课程表</el-button>
            <el-button type="text" v-else @click="details(row)">查看课程表</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="toReload"></edit-dialog>
    <import-dialog ref="importDialog" @upload-success="toReload" />
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/ed/curriculum/list";
import editDialog from "@/components/ed/curriculum/editDialog";
import importDialog from "@/components/ed/curriculum/importDialog";
import exportDialog from "@/components/ed/curriculum/exportDialog";

export default {
  name: "curriculum",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    exportDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    importTT() {
      // this.$refs.importDialog.TermId = sessionStorage.getItem("termId");
      // this.$refs.importDialog.TermName = sessionStorage.getItem("termName");
      var TermId = sessionStorage.getItem("termId");
      var TermName = sessionStorage.getItem("termName");
      this.$refs.importDialog.open().then((that) => {
        that.setTerm({ TermId, TermName });
      });
    },
    exportTT() {
      this.$refs.exportDialog.open().then((that) => {
        var TermId = sessionStorage.getItem("termId");
        that.setDate(TermId);
      });
    },
    details(row) {
      this.$refs.editDialog.openDetails(row);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.CurriculumId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    toReload() {
      this.$refs.list.reload();
    },
    reload() {},
  },
};
</script>